/* Lumbrely — scripts propios (prefijo lb-) */
(function () {
  function initReveal() {
    var els = document.querySelectorAll('.lb-reveal:not(.lb-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('lb-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('lb-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  // Cuenta atrás hasta una fecha real (data-fin="2026-11-30T23:59").
  // Si la fecha ya pasó o no es válida, el contador se oculta.
  function initTimers() {
    var timers = document.querySelectorAll('[data-lb-fin]');
    if (!timers.length) return;
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var now = Date.now();
      timers.forEach(function (t) {
        var fin = Date.parse(t.getAttribute('data-lb-fin'));
        var box = t.closest('[data-lb-timer-box]') || t;
        if (isNaN(fin) || fin <= now) { box.style.display = 'none'; return; }
        var s = Math.floor((fin - now) / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        t.textContent = (d > 0 ? d + 'd ' : '') + (d > 0 || h > 0 ? pad(h) + ':' : '') + pad(m) + ':' + pad(s);
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  function formatMoney(cents, fmt) {
    fmt = fmt || '${{amount}}';
    function num(n, dec, th, ds) {
      var s = (n / 100).toFixed(dec).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return s[1] ? s[0] + ds + s[1] : s[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return num(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return num(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return num(cents, 0, '.', ',');
      return num(cents, 2, ',', '.');
    }).replace(/<[^>]*>/g, '');
  }

  function initProductos() {
    document.querySelectorAll('[data-lb-producto]:not([data-lb-ok])').forEach(function (root) {
      root.setAttribute('data-lb-ok', '');
      var dataEl = root.querySelector('[data-lb-variantes]');
      if (!dataEl) return;
      var data = JSON.parse(dataEl.textContent);
      var variants = data.variants;
      var form = root.querySelector('[data-lb-form]');
      var idInput = root.querySelector('[data-lb-variant-id]');
      var qtyInput = root.querySelector('[data-lb-cantidad]');
      var btn = root.querySelector('[data-lb-comprar]');
      var err = root.querySelector('[data-lb-error]');
      var precioEl = root.querySelector('[data-lb-precio]');
      var antesEl = root.querySelector('[data-lb-precio-antes]');
      var packs = root.querySelectorAll('[data-lb-pack]');
      var opciones = root.querySelectorAll('[data-lb-opcion]');
      var current = variants.find(function (v) { return v.id == idInput.value; }) || variants[0];
      var cantidad = parseInt(qtyInput.value, 10) || 1;
      var pagas = parseInt(qtyInput.dataset.pagas, 10) || cantidad;
      var activo = root.querySelector('[data-lb-pack].is-active');
      if (activo) pagas = parseInt(activo.dataset.pagas, 10) || cantidad;

      function render() {
        idInput.value = current.id;
        qtyInput.value = cantidad;
        if (precioEl) precioEl.textContent = formatMoney(current.price * pagas, data.money_format);
        if (antesEl) {
          antesEl.textContent = formatMoney(current.price * cantidad, data.money_format);
          antesEl.style.display = cantidad > pagas ? '' : 'none';
        }
        packs.forEach(function (p) {
          var c = parseInt(p.dataset.cantidad, 10), pg = parseInt(p.dataset.pagas, 10);
          var pe = p.querySelector('[data-lb-pack-precio]'), ae = p.querySelector('[data-lb-pack-antes]');
          if (pe) pe.textContent = formatMoney(current.price * pg, data.money_format);
          if (ae) ae.textContent = formatMoney(current.price * c, data.money_format);
        });
        // Marca tallas agotadas (para producto de una sola opción)
        if (opciones.length === 1) {
          opciones[0].querySelectorAll('[data-lb-valor]').forEach(function (b) {
            var v = variants.find(function (x) { return x.options[0] === b.dataset.lbValor; });
            b.classList.toggle('is-agotado', !!v && !v.available);
          });
        }
        var stockEl = root.querySelector('[data-lb-stock]');
        if (stockEl) {
          var st = stockEl.dataset, txt = stockEl.querySelector('[data-lb-stock-texto]');
          var umbral = parseInt(st.umbral, 10) || 0, n = current.stock;
          var poco = current.available && n !== null && n > 0 && n <= umbral;
          stockEl.classList.toggle('is-agotado', !current.available);
          txt.textContent = !current.available ? st.textoAgotado : (poco ? st.textoPoco.replace('[cantidad]', n) : st.textoOk);
        }
        btn.disabled = !current.available;
        btn.textContent = current.available ? root.dataset.textoBoton : root.dataset.textoAgotado;
        if (err) err.textContent = '';
      }

      packs.forEach(function (p) {
        p.addEventListener('click', function () {
          packs.forEach(function (x) { x.classList.remove('is-active'); });
          p.classList.add('is-active');
          cantidad = parseInt(p.dataset.cantidad, 10) || 1;
          pagas = parseInt(p.dataset.pagas, 10) || cantidad;
          render();
        });
      });

      opciones.forEach(function (fs) {
        fs.querySelectorAll('[data-lb-valor]').forEach(function (b) {
          b.addEventListener('click', function () {
            fs.querySelectorAll('[data-lb-valor]').forEach(function (x) { x.classList.remove('is-active'); });
            b.classList.add('is-active');
            var sel = [];
            opciones.forEach(function (o) {
              var a = o.querySelector('.is-active');
              sel.push(a ? a.dataset.lbValor : null);
            });
            var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
            if (v) current = v;
            var el = fs.querySelector('[data-lb-elegido]');
            if (el) el.textContent = b.dataset.lbValor;
            // Si la variante tiene foto propia, la galería salta a esa foto
            if (current.imagen > -1) root.dispatchEvent(new CustomEvent('lb:foto', { detail: current.imagen }));
            render();
          });
        });
      });

      root.querySelectorAll('[data-lb-abrir-guia]').forEach(function (a) {
        a.addEventListener('click', function () {
          var d = document.querySelector(a.getAttribute('href'));
          if (d) d.open = true;
        });
      });

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          btn.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: current.id, quantity: cantidad }] })
          }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
            .then(function (res) {
              if (!res.ok) throw new Error(res.j.description || res.j.message || 'Error');
              if (root.dataset.destino === 'drawer' && window.lbAbrirCarrito) {
                window.lbAbrirCarrito();
                btn.disabled = !current.available;
                return;
              }
              window.location.href = root.dataset.destino === 'cart' ? '/cart' : '/checkout';
            })
            .catch(function (ex) {
              if (err) err.textContent = ex.message;
              btn.disabled = !current.available;
            });
        });
      }

      // Galería deslizable (dedo en móvil, arrastre con ratón, flechas y miniaturas)
      var gal = root.querySelector('[data-lb-galeria]');
      var pista = gal && gal.querySelector('[data-lb-pista]');
      if (pista) {
        var slides = pista.children;
        var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-lb-thumb]'));
        var puntos = Array.prototype.slice.call(gal.querySelectorAll('[data-lb-punto]'));
        var total = slides.length, idx = 0;
        var tFix;
        function irA(i, suave) {
          idx = (i + total) % total;
          var destino = idx * pista.clientWidth;
          pista.scrollTo({ left: destino, behavior: suave === false ? 'auto' : 'smooth' });
          // Si el navegador no termina la animación, coloca la foto directamente
          clearTimeout(tFix);
          tFix = setTimeout(function () {
            if (Math.abs(pista.scrollLeft - destino) > 2) pista.scrollLeft = destino;
            marcar();
          }, 600);
        }
        function marcar() {
          var i = Math.round(pista.scrollLeft / Math.max(1, pista.clientWidth));
          if (i < 0 || i >= total) return;
          idx = i;
          thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === idx); });
          puntos.forEach(function (p, j) { p.classList.toggle('is-active', j === idx); });
          if (thumbs[idx]) {
            var cont = thumbs[idx].parentElement;
            var l = thumbs[idx].offsetLeft - cont.clientWidth / 2 + thumbs[idx].clientWidth / 2;
            cont.scrollTo({ left: l, behavior: 'smooth' });
          }
        }
        var tMarcar;
        pista.addEventListener('scroll', function () { clearTimeout(tMarcar); tMarcar = setTimeout(marcar, 60); }, { passive: true });
        thumbs.forEach(function (t, i) { t.addEventListener('click', function () { irA(i); }); });
        var prev = gal.querySelector('[data-lb-prev]'), next = gal.querySelector('[data-lb-next]');
        if (prev) prev.addEventListener('click', function () { irA(idx - 1); });
        if (next) next.addEventListener('click', function () { irA(idx + 1); });
        // Arrastrar con el ratón en ordenador
        var arrastrando = false, x0 = 0, s0 = 0, movido = false;
        pista.addEventListener('mousedown', function (e) {
          arrastrando = true; movido = false; x0 = e.clientX; s0 = pista.scrollLeft;
          pista.classList.add('is-arrastrando');
          e.preventDefault();
        });
        window.addEventListener('mousemove', function (e) {
          if (!arrastrando) return;
          var dx = e.clientX - x0;
          if (Math.abs(dx) > 3) movido = true;
          pista.scrollLeft = s0 - dx;
        });
        window.addEventListener('mouseup', function (e) {
          if (!arrastrando) return;
          arrastrando = false;
          pista.classList.remove('is-arrastrando');
          var dx = e.clientX - x0, umbral = pista.clientWidth * 0.15;
          if (dx < -umbral) irA(idx + 1); else if (dx > umbral) irA(idx - 1); else irA(idx);
        });
        window.addEventListener('resize', function () { irA(idx, false); });
        root.addEventListener('lb:foto', function (e) { irA(e.detail); });
      }

      // Barra fija
      var sticky = root.querySelector('[data-lb-sticky]');
      if (sticky && btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(btn);
        var sb = sticky.querySelector('[data-lb-sticky-btn]');
        if (sb) sb.addEventListener('click', function (ev) {
          if (sb.getAttribute('href') !== '#') return;
          ev.preventDefault();
          (root.querySelector('.lb-packs') || form).scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }

      render();
    });
  }

  // Botones con enlace vacío: suben al selector de pack/talla
  function initSubir() {
    document.querySelectorAll('[data-lb-subir]:not([data-lb-ok])').forEach(function (a) {
      a.setAttribute('data-lb-ok', '');
      if (a.getAttribute('href') !== '#') return;
      var check = document.querySelector('[data-lb-check]');
      if (check) { a.setAttribute('href', check.getAttribute('href')); return; }
      a.addEventListener('click', function (e) {
        var destino = document.querySelector('.lb-packs') || document.querySelector('[data-lb-form]');
        if (!destino) return;
        e.preventDefault();
        destino.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  // Estrellas → abrir el formulario "Write a review"
  function abrirResena(scroll) {
    var d = document.querySelector('[data-lb-escribir]');
    if (!d) return false;
    d.open = true;
    if (scroll) d.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }
  function initResenas() {
    document.querySelectorAll('[data-lb-ir-resena]:not([data-lb-ok])').forEach(function (a) {
      a.setAttribute('data-lb-ok', '');
      a.addEventListener('click', function (e) {
        if (abrirResena(true)) e.preventDefault();
      });
    });
    // Estrellas → bajar a la sección de reseñas (compensando la cabecera fija)
    document.querySelectorAll('[data-lb-ir-resenas]:not([data-lb-ok])').forEach(function (a) {
      a.setAttribute('data-lb-ok', '');
      a.addEventListener('click', function (e) {
        var s = document.getElementById('lb-resenas') || document.getElementById('looxReviews') ||
          document.querySelector('.loox-widget, .jdgm-widget, #judgeme_product_reviews, .shopify-app-block[id*="review"]');
        if (!s) return;
        var sec = s.closest('.shopify-section');
        if (sec && s.id !== 'lb-resenas') s = sec;
        e.preventDefault();
        var cab = document.querySelector('.section-header, sticky-header');
        var alto = cab ? cab.getBoundingClientRect().height : 0;
        var destino = s.getBoundingClientRect().top + window.pageYOffset - alto - 10;
        var inicio = window.pageYOffset;
        window.scrollTo({ top: destino, behavior: 'smooth' });
        // Respaldo: si el navegador no anima, salta directamente
        setTimeout(function () { if (Math.abs(window.pageYOffset - inicio) < 5) window.scrollTo(0, destino); }, 400);
      });
    });
    if (location.hash === '#lb-escribir-resena' || document.querySelector('[data-lb-resena-ok]')) {
      setTimeout(function () { abrirResena(true); }, 300);
    }
  }

  // Página "Check Availability": pack + talla + extras → carrito → checkout
  function initCheckout() {
    var root = document.querySelector('[data-lb-checkout]:not([data-lb-ok])');
    if (!root) return;
    root.setAttribute('data-lb-ok', '');
    var datos = JSON.parse(root.querySelector('[data-lb-co-datos]').textContent);
    var fmt = function (c) { return formatMoney(c, datos.money_format); };
    var bundles = Array.prototype.slice.call(root.querySelectorAll('[data-lb-bundle]'));
    var extras = Array.prototype.slice.call(root.querySelectorAll('[data-lb-extra]'));
    var btn = root.querySelector('[data-lb-co-comprar]');
    var err = root.querySelector('[data-lb-co-error]');
    var resumen = root.querySelector('[data-lb-resumen]');
    if (resumen && window.innerWidth < 900) resumen.open = false;
    var activo = root.querySelector('[data-lb-bundle].is-active') || bundles[0];
    var seleccion = [];

    function variante() {
      return datos.variants.find(function (v) {
        return v.options.every(function (o, i) { return seleccion[i] == null || o === seleccion[i]; });
      }) || datos.variants[0];
    }
    function leerSeleccion() {
      seleccion = [];
      if (!activo) return;
      activo.querySelectorAll('[data-lb-co-opcion]').forEach(function (o) {
        var a = o.querySelector('.is-active');
        seleccion.push(a ? a.dataset.lbValor : null);
      });
    }
    var icoExtra = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg>';
    function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

    function render() {
      leerSeleccion();
      var v = variante();
      var cant = activo ? parseInt(activo.dataset.cantidad, 10) : 1;
      var pagas = activo ? parseInt(activo.dataset.pagas, 10) : cant;
      bundles.forEach(function (b) {
        var pe = b.querySelector('[data-lb-b-precio]'), ae = b.querySelector('[data-lb-b-antes]');
        if (pe) pe.textContent = fmt(v.price * parseInt(b.dataset.pagas, 10));
        if (ae) ae.textContent = fmt(v.price * parseInt(b.dataset.cantidad, 10));
      });
      // Marca tallas agotadas o sin unidades suficientes para el pack
      if (activo) {
        var ops = activo.querySelectorAll('[data-lb-co-opcion]');
        if (ops.length === 1) {
          ops[0].querySelectorAll('[data-lb-valor]').forEach(function (b) {
            var x = datos.variants.find(function (y) { return y.options[0] === b.dataset.lbValor; });
            b.classList.toggle('is-agotado', !!x && (!x.available || (x.stock !== null && x.stock < cant)));
          });
        }
      }
      // Indicador de stock real
      var st = root.querySelector('[data-lb-stock]');
      var hayStock = v.available && (v.stock === null || v.stock >= cant);
      if (st) {
        var t = st.querySelector('[data-lb-stock-texto]'), umbral = parseInt(root.dataset.umbral, 10) || 0;
        st.classList.toggle('is-agotado', !hayStock);
        if (!hayStock) t.textContent = root.dataset.textoAgotado;
        else if (v.stock !== null && v.stock <= umbral) t.textContent = root.dataset.textoPoco.replace('[cantidad]', v.stock);
        else t.textContent = root.dataset.textoOk;
      }
      // Resumen
      var lineas = '', total = v.price * pagas;
      var img = root.querySelector('.lb-co__bundle.is-active .lb-co__bundle-img');
      lineas += '<div class="lb-co__linea"><span class="lb-co__linea-img">' + (img ? '<img src="' + img.currentSrc + '" alt="">' : '') +
        '<span class="lb-co__linea-q">' + cant + '</span></span><span class="lb-co__linea-info">' + esc(activo ? activo.dataset.titulo : datos.product_title) +
        '<small>' + esc(v.title) + (activo && activo.dataset.envio ? ' · ' + esc(activo.dataset.envio) : '') + '</small></span><span class="lb-co__linea-precio">' +
        (cant > pagas ? '<s>' + fmt(v.price * cant) + '</s>' : '') + fmt(v.price * pagas) + '</span></div>';
      extras.forEach(function (x) {
        if (!x.checked) return;
        total += parseInt(x.dataset.precio, 10);
        lineas += '<div class="lb-co__linea"><span class="lb-co__linea-img">' + icoExtra + '<span class="lb-co__linea-q">1</span></span><span class="lb-co__linea-info">' +
          esc(x.dataset.titulo) + '</span><span class="lb-co__linea-precio">' + fmt(parseInt(x.dataset.precio, 10)) + '</span></div>';
      });
      root.querySelector('[data-lb-lineas]').innerHTML = lineas;
      root.querySelector('[data-lb-total]').textContent = fmt(total);
      var cab = root.querySelector('[data-lb-total-cab]');
      if (cab) cab.textContent = fmt(total);
      btn.disabled = !hayStock;
      if (err) err.textContent = '';
    }

    bundles.forEach(function (b) {
      b.querySelector('.lb-co__bundle-fila').addEventListener('click', function () {
        if (activo === b) return;
        // Mantiene la talla elegida al cambiar de pack
        var prev = activo ? activo.querySelectorAll('[data-lb-co-opcion]') : [];
        var vals = Array.prototype.map.call(prev, function (o) { var a = o.querySelector('.is-active'); return a ? a.dataset.lbValor : null; });
        bundles.forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        activo = b;
        b.querySelectorAll('[data-lb-co-opcion]').forEach(function (o, i) {
          if (vals[i] == null) return;
          o.querySelectorAll('[data-lb-valor]').forEach(function (x) { x.classList.toggle('is-active', x.dataset.lbValor === vals[i]); });
        });
        render();
      });
      b.querySelectorAll('[data-lb-co-opcion]').forEach(function (o) {
        o.querySelectorAll('[data-lb-valor]').forEach(function (x) {
          x.addEventListener('click', function () {
            o.querySelectorAll('[data-lb-valor]').forEach(function (y) { y.classList.remove('is-active'); });
            x.classList.add('is-active');
            render();
          });
        });
      });
    });
    extras.forEach(function (x) { x.addEventListener('change', render); });

    btn.addEventListener('click', function () {
      leerSeleccion();
      var v = variante();
      var cant = activo ? parseInt(activo.dataset.cantidad, 10) : 1;
      var items = [{ id: v.id, quantity: cant }];
      extras.forEach(function (x) { if (x.checked) items.push({ id: parseInt(x.dataset.id, 10), quantity: 1 }); });
      btn.disabled = true;
      var txt = btn.textContent;
      btn.textContent = '…';
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Error');
          window.location.href = '/checkout';
        })
        .catch(function (ex) {
          if (err) err.textContent = ex.message;
          btn.textContent = txt;
          btn.disabled = false;
        });
    });

    render();
  }

  function init() { initReveal(); initTimers(); initProductos(); initSubir(); initResenas(); initCheckout(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
